import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgLoading({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <circle
        fill="none"
        stroke="#373A3C"
        strokeWidth={7}
        strokeMiterlimit={15}
        strokeDasharray={15}
        cx={50}
        cy={50}
        r={47}
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="5s"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        fill="none"
        stroke="#373A3C"
        strokeMiterlimit={10}
        strokeDasharray={15}
        cx={50}
        cy={50}
        r={39}
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="5s"
          from="0 50 50"
          to="-360 50 50"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
}
export default SvgLoading;
